import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

export default function ChangePrice({ onClick }) {
  return (
    <button
      id="changeprice"
      className="c-action-primary hover-c-action-primary pv4 ph5 f6 f5-ns bn bg-transparent pointer"
      onClick={onClick}
    >
      <FormattedMessage id="changePriceLabel" />
    </button>
  )
}

ChangePrice.propTypes = {
  onClick: PropTypes.func.isRequired,
}
